import PersonalAccidentNeeds from '@master/model/kyc-form/need-analysis/health/PersonalAccidentNeeds'
import { sum } from '@master/model/kyc-form/need-analysis/math'

export default class CustomPersonalAccidentNeeds extends PersonalAccidentNeeds {
  get surplusShortfall () {
    return sum(-this.amount, this.sumAvailable, -this.sumRequired)
  }
}
